import { useState, useEffect } from "react";

export const useCountdown = (initialTime?: number) => {
  const [timeRemaining, setTimeRemaining] = useState(initialTime ?? 0);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeRemaining(prevTime => {
        if (prevTime <= 0) {
          clearInterval(timer);
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return {
    timeRemaining,
  };
};
